import headshot from "../resources/headshot.jpg";

function Personal() {
  return (
    <div>
      <div className="display-left ml-5 w-80 mt-5">
        <div>
          <h1 className="primary sub-22 mb-0">Hi, my name is Ryan.</h1>
          <h1 className="heading white">I love building software.</h1>
          <h1 className="primary sub">
            I am a full-stack software engineer with professional experience in
            Laravel, VueJS and PL/SQL.
          </h1>
          <h1 className="white sub-two">Check out my work below</h1>
        </div>
      </div>
    </div>
  );
}

export default Personal;
